import { render, staticRenderFns } from "./FormActividad.vue?vue&type=template&id=08615fd3&scoped=true&"
import script from "./FormActividad.vue?vue&type=script&lang=js&"
export * from "./FormActividad.vue?vue&type=script&lang=js&"
import style0 from "./FormActividad.vue?vue&type=style&index=0&id=08615fd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08615fd3",
  null
  
)

export default component.exports